import { Stack } from '@landler/component-library';
import { cn } from 'component-library/utils';
import React from 'react';

type Column<T> = {
  key: string;
  label: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  render?: (value: any, row: T, rowIndex: number) => React.ReactNode;
  className?: string;
};

type SimpleTableStyles = {
  header?: string;
  row?: string;
};

type SimpleTableProps<T> = {
  columns: Column<T>[];
  data: T[];
  className?: string;
  styles?: SimpleTableStyles;
  noDataRow?: React.ReactNode;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const SimpleTable = <T extends Record<string, any>>({
  columns,
  data,
  className = '',
  styles = {},
  noDataRow,
}: SimpleTableProps<T>) => {
  return (
    <Stack className={cn('border-xl border-neutral-black-12', className)}>
      <table className={cn('typography-body2 w-full table-auto overflow-hidden rounded-3xl', className)}>
        <thead>
          <tr className={cn('border-b border-neutral-black-12 typography-overline text-text-secondary', styles.header)}>
            {columns.map((col, index) => (
              <th key={`${col.key}-${index}`} className={cn('typography-overline p-4 text-left', col.className)}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='[&>*:not(:last-child)]:border-b [&>*:not(:last-child)]:border-[#e0e0e0]'>
          {data.length === 0
            ? noDataRow || (
                <tr>
                  <td colSpan={columns.length} className='p-4 text-center text-gray-400'>
                    No data
                  </td>
                </tr>
              )
            : data.map((row, rowIndex) => (
                <tr
                  key={rowIndex}
                  className={cn('text-text-primary typography-body2 hover:bg-neutral-black-4 m-6', styles.row)}
                >
                  {columns.map((col, index) => (
                    <td key={`${col.key}-${index}`} className={cn('px-6 py-2', col.className)}>
                      {col.render ? col.render(row[col.key], row, rowIndex) : (row[col.key] as React.ReactNode)}
                    </td>
                  ))}
                </tr>
              ))}
        </tbody>
      </table>
    </Stack>
  );
};
